import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import useCredencialesNotificadores from "../../../api/credencialesNotificadores";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const ModalCargarNotificador = () => {
  //? ESTADOS GLOBALES
  const { modals, loads, handlerModal } = useGeneralAppStore();
  const { cargarNotificador } = useCredencialesNotificadores();

  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      razon_social: null,
      documento: null,
      genero: null,
    },
  });

  const onSubmit = (formData) => {
    // console.log({ formData });

    let values = formData;

    if (values.genero === "-") {
      values.genero = null;
    }

    cargarNotificador(values);
    handlerModal({ modal: false, modalName: "cargar_notificador" });
  };

  return (
    <>
      <Modal
        backdrop={"static"}
        show={modals.includes("cargar_notificador")}
        size={"lg"}
        onHide={() => handlerModal({ modal: false, modalName: "cargar_notificador" })}
        title={() => `Cargar Notificador`}
      >
        <div className="alert alert-primary" role="alert">
          <span>Aquellos campos marcados con * son obligatorios.</span>
        </div>

        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12">
              <Form.Group controlId="validationCustom01">
                <Form.Label htmlFor="razon_social">Razón Social *</Form.Label>
                <Form.Control
                  required
                  type="text"
                  id="razon_social"
                  aria-describedby="razonSocialHelpMeBlock"
                  {...register("razon_social")}
                />
                <Form.Text id="razonSocialHelpMeBlock" muted>
                  La razón social del notificador a cargar debe ser cargada como: APELLIDO, NOMBRE
                  en caso de ser una persona.
                </Form.Text>

                {watch("razon_social") === null ||
                  (watch("razon_social") === "" && (
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                  ))}
              </Form.Group>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-6">
              <Form.Label htmlFor="documento">Documento *</Form.Label>
              <Form.Control required type="text" id="documento" {...register("documento")} />
            </div>
            <div className="col-6">
              <Form.Label htmlFor="genero">Género</Form.Label>
              <Form.Select
                aria-label="select genero"
                id="genero"
                defaultValue=""
                {...register("genero")}
              >
                <option disabled value="">
                  Seleccione un género
                </option>
                <option value="M">Másculino</option>
                <option value="F">Femenino</option>
                <option value="X">Otro</option>
                <option value="-">Ninguno</option>
              </Form.Select>
            </div>
          </div>

          <div className="row"></div>

          <div className="row mt-4">
            <div className="d-flex gap-1 justify-content-center">
              <button
                disabled={!watch("razon_social") || loads.includes("cargar-notificador")}
                className="btn btn-primary"
                type="submit"
              >
                Cargar Notificador
              </button>
            </div>
          </div>

          {loads.includes("cargar-notificador") && (
            <div
              className="d-flex justify-content-center align-items-center mt-2"
              style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            >
              <MuniSpinner2 />
            </div>
          )}
        </Form>
      </Modal>
    </>
  );
};
export default ModalCargarNotificador;
